document.addEventListener('DOMContentLoaded',function() {

    const cover = document.getElementById('cover');
    
    const init = function() {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
        
        setTimeout(function() {
            window.inViewInit();
            cover.remove();
        }, 250);  
    };
    
    window.addEventListener('load', init);

}, false);